import React from 'react'
import { useStyles } from '../../auth/dialogs/forgottenPasswordDialog.css'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import { Trans } from 'react-i18next'
import CloseButton from 'components/dialogs/closeButton'
import AccountForm, { AccountFormState } from 'components/forms/account/accountForm'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'

interface Props {
    open: boolean
    onClose: () => void
    onSubmit: (values: AccountFormState) => void
    inProgress: boolean
    initialValues: AccountFormState
}

const AccountDialogView: React.FC<Props> = ({ open, onClose, ...formData }) => {
    const classes = useStyles()

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
        >
            <AccountForm formClassName={classes.form} {...formData}>
                {(content, actions) => (
                    <>
                        <DialogTitle>
                            <Trans i18nKey="views.account.title" />
                        </DialogTitle>
                        <DialogContent dividers>
                            <CloseButton onClose={onClose} />
                            {content}
                        </DialogContent>
                        <DialogActions className={classes.actions}>
                            <Button variant="contained" onClick={onClose}>
                                <Trans i18nKey="actions.cancel" />
                            </Button>
                            {actions.map((action, index) => (
                                <SubmitButton
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    {...action}
                                    className={clsx(action.className)}
                                />
                            ))}
                        </DialogActions>
                    </>
                )}
            </AccountForm>
        </Dialog>
    )
}

export default AccountDialogView
